import Monthly from './Monthly';
import Annually from './Annually';
import Daily from './Daily';
import React from 'react';

const RegularityType = React.memo(({ type, ...props }) => {
    switch (type) {
        case 'monthly':
            return <Monthly {...props} />;
        case 'annually':
            return <Annually {...props} />;
        case 'daily':
            return <Daily {...props} />;
        default:
            return <></>;
    }
});

export default RegularityType;